import { ACTION, AdParam, STATUS_ERROR, URL_BASE, _DESKTOP_ } from './contanst'

export class Advertising {
  constructor (data) {
    this.data = data
    this.container = {}
  }

  executeScript (script) {
    if (!script.src) {
      const f = new Function(script.textContent)
      f()
    } else {
      const s = document.createElement('script')
      s.src = script.src
      document.head.appendChild(s)
    }
  }

  /**
         *
         * @returns {undefined}
         */
  init () {
    this.container = document.querySelector(`[data-element="${this.data.id}"]`)
    this.container.innerHTML = this.data.html
    if (this.data.ads[-1]) {
      this.container.querySelectorAll('script').forEach(this.executeScript)
    }
    this.container.querySelectorAll('[data-type="3"] iframe').forEach((iframe) => {
      iframe.onload = () => {
        const doc = iframe.contentDocument
        const style = document.createElement('style')
        style.innerHTML = 'body{margin:0;padding:0;overflow:hidden;}'
        doc.head.append(style)
      }
    })
  }

  /**
         * funcion para el setear la accion de click en una publicidad
         * @param {type} elements
         * @returns {undefined}
         */
  addClick (elements) {
    const _this = this
    for (let i = 0; i < elements.length; i++) {
      elements[i].addEventListener('click', function clickAd () {
        const code = _this.getCodeAd(this)
        _this.AddDispatched(_this.data.ads[code], ACTION.click, (!_this.data.containerClick))
        this.removeEventListener('click', clickAd, false)
      })
    }
  }

  /**
         * se guarda el dispositivo en el que se esta mostrando la publicadad
         * @param int media
         * @returns null
         */
  setMedia (media) {
    this.data.media = media
  }

  /**
         * se obtenien el codigo de la publicadad desde el atributo id del elemento
         * @param {type} element
         * @returns {Number|CAdvertising.getCodeAd.list|String}
         */
  getCodeAd (element) {
    const css = element.classList
    let code = 0
    for (let i = 0; i < css.length; i++) {
      if (css[i].indexOf('Ad-') != -1) {
        const list = css[i].split('-')
        code = list.length == 3 ? list[1] : '-' + list[2]
      }
    }
    return code
  }

  /**
         * funcion para el setear la accion de cuando aparece en pantalla en una publicidad
         * @param {type} elements
         * @returns null
         */
  addPrint (elements) {
    const _this = this
    let container = document.querySelector(`[data-element="${this.data.id}"]`)
    let topAD = container.offsetTop
    /* busco la altura especifica en donde empiza el contenedor */
    while (1) {
      if (container.offsetParent) {
        container = container.offsetParent
        topAD += container.offsetTop
      } else {
        break
      }
    }
    /* funcion que verifica si esta en la posicion especifica y si no fue ya ejecutado el imprimir */
    const printDispatched = () => {
      const posScreen = window.scrollY + container.clientHeight
      if (posScreen > topAD && posScreen < (topAD + container.clientHeight)) {
        for (let i = 0; i < elements.length; i++) {
          if (elements.length == 1 || elements[i].classList.contains('active')) {
            const code = _this.getCodeAd(elements[i])
            if (!_this.data.ads[code].print) {
              _this.addScriptPrint(_this.data.ads[code])
              _this.AddDispatched(_this.data.ads[code], ACTION.print, (!_this.data.containerPrint))
              _this.data.ads[code].print = true
              _this.data.containerPrint = true
            }
            return
          }
        }
      }
    }
    window.addEventListener('scroll', printDispatched)
    if (elements.length > 1) { document.getElementById('carousel-' + this.data.id).addEventListener('slid.bs.carousel', printDispatched) }

    printDispatched()
  }

  /**
         * se agrega el script que tiene acciones de tercero para cuando se muestra la publicidad
         * @returns null
         */
  addScriptPrint (ad) {
    if (ad.scriptPrint != null) {
      const container = document.querySelector(`[data-element="${this.data.id}"]`)
      const div = document.createElement('div')
      div.innerHTML = ad.scriptPrint
      container.append(div)
      div.querySelectorAll('script').forEach(this.executeScript)
    }
  }

  /**
         * creacion de carousel de publicidad
         * @returns null
         */
  createCarousel () {
    const carousel = document.querySelector(`[data-element="${this.data.id}"]`)
    carousel.querySelector('.item').classList.add('active')
    if (this.data.media === _DESKTOP_) {
      carousel.querySelector('.carousel-inner').style.minHeight = this.data.dimensions.desktop.height + 'px'
    } else {
      carousel.querySelector('.carousel-inner').style.minHeight = this.data.dimensions.movil.height + 'px'
    }

    const carouselControl = new bootstrap.Carousel(carousel, {
      interval: (this.data.carousel.interval * 1000),
      ride: 'carousel'
    })
    if (carousel.querySelector('video')) {
      const videos = carousel.querySelectorAll('.carousel-item:not(.active) video')
      for (let i = 0; i < videos.lenght; i++) {
        videos[i].pause()
      }
      carousel.addEventListener('slide.bs.carousel', function () {
        if (this.querySelector('.active video')) {
          this.querySelector('.active video').pause()
        }
      })
      carousel.addEventListener('slid.bs.carousel', function () {
        if (this.querySelector('.active video')) {
          this.querySelector('.active video').play()
        }
      })
    }
    carouselControl.cycle()
  }

  /**
         * llamado a calledAdvertisign para setear la impresion de  tantalla o un click
         * @param {type} ad
         * @param int event
         * @param bool eventContainer envia true si ahi que setear un evento en la tabla del historico del contenedor en caso contrario flase
         * @returns {undefined}
         */
  AddDispatched (ad, event, eventContainer) {
    if (AdParam.development) {
      return
    }
    const data = {
      codeAd: ad.codeAd,
      codeRemote: ad.remote,
      version: ad.version,
      section: this.data.section,
      media: this.data.media
    }
    /*  if (eventContainer) { */
    data.idContainer = this.data.idContainer
    data.addContainer = true
    data.origin = ad.origin
    /* } else {
                 data.addContainer = false;
                 } */
    fetch(`${URL_BASE}/${event == ACTION.click ? 'setClick' : 'setPrint'}`, {
      method: 'POST',
      body: JSON.stringify(data)
    }).then(r => r.json())
      .then(json => this.OnResponse(json))
  }

  OnResponse (Response) {
    if (Response.Status === STATUS_ERROR) {
      console.error('PUBLICIDAD: ERROR ' + Response.Message)
      return
    }
    switch (Response.Action) {
      case 1:
        // console.log("PUBLICIDAD: agregado correctamente el evento " + (Response.Data.event == CLICK ? "click" : "print") + " AD-" + Response.Data.ad);
        break
    }
  }

  show = function () {

  }
}
